import React from "react";
import "./css/Member.css";

export default function MembersSection() {
  const members = [
        { name: "सौ. माधुरी गणेश शेलार", role: "संगणक परिचालक" },

            { name: "सौ. स्वाती निलेश घोरपडे", role: "रोजगार सेवक" },

    { name: "सौ. रेखाताई संजय घोरपडे", role: "सदस्य" },
    { name: "श्री. दिलीप विठ्ठल भोसले", role: "सदस्य" },
    { name: "श्री. सचिन शिवराम कदम", role: "सदस्य" },

    { name: "सौ. वनिता संदीप गोसावी", role: "सदस्य" },
    { name: "श्री. शंकर आबा कदम", role: "सदस्य" },
    { name: "श्री. राजेंद्र नारायण माने", role: "सदस्य" },

  ];

  return (
    <section className="members-section">
      <div className="members-grid">
        {members.map((m, index) => (
          <div className="member-card" key={index}>
            <p className="member-name">{m.name}</p>
            <p className="member-role">{m.role}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
